import IdentityVerificationAttemptQuestions from '@/models/identity-verification/IdentityVerificationAttemptQuestions.js';
import Model from '@/models/Model.js';
import User from '@/models/User.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class IdentityVerification extends Model {
    static entity = 'identity-verification';

    static queryBuilder(id = null) {
        const endpoint = id ? `${this.entity}/${id}` : this.entity;

        return new QueryBuilder(endpoint);
    }

    static fields() {
        return {
            user_id: this.attr(null),
            expires: this.string(''),
            id: this.attr(null),
            user: this.attr(null),
            identity_verification_attempt: this.attr(null),
            failed_attempt: this.attr(false),
            passed_attempt: this.attr(false),
            next_route_on_success: this.attr(null),
            error: this.attr(null),

            ...super.fields(),
        };
    }

    static async fetch(id, to = null) {
        const response = await this.api().get(this.queryBuilder(id).toUrl(), {
            persistBy: 'create',
            save: false,
        });

        response.response.data.data.next_route_on_success = to;

        response.save();

        return response.response.data;
    }

    static async buildAttempt(userId) {
        const user = User.find(userId);

        const id = user?.identity_verification_active_id;
        const attemptId = user?.identity_verification_attempt_active_id;

        if (id && !this.find(id)) {
            await this.fetch(id);
        }

        const endpoint = new QueryBuilder('identity-verification-attempt-questions');

        endpoint.filter('identity_verification_attempt_id', attemptId);

        endpoint.include(['question', 'choices.choice']);

        const questions = await IdentityVerificationAttemptQuestions.fetch(endpoint.toUrl());

        await IdentityVerificationAttemptQuestions.insert({
            data: questions.data,
        });

        return id;
    }
}
